export function truncateFieldValueToCharacterLimit<T>(
  value: T,
  maxLength?: number | null
): T | string {
  if (typeof maxLength !== 'number' || !Number.isFinite(maxLength)) {
    return value
  }

  return Array.from(String(value ?? ''))
    .slice(0, maxLength)
    .join('')
}
